import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import CampaignScenario from './CampaignScenario'

export default observer(function CampaignReport() {
  const { campaignScenarios } = useContext(CampaignContext)
  const primaryScenario = campaignScenarios[0]

  if (!primaryScenario) return null

  return (
    <div className="border-1 dark:border-rb-dark-mode-lighter rounded-md p-4 mt-4">
      <p className="text-sm font-bold mb-4 dark:text-white">Campaign report</p>
      <div className="flex flex-wrap gap-4">
        <CampaignScenario campaignScenario={primaryScenario} visibilityKind="report" />
      </div>
    </div>
  )
})
